export const environment = {
	production: false,
	backendServerUrl: 'https://backend.stream-qa.zerohour-productions.net:12443',
	websocketServerUrl: 'wss://backend.stream-qa.zerohour-productions.net:12443'
};
